import { render } from "./ManageChannel.vue?vue&type=template&id=ff247df4&scoped=true"
import script from "./ManageChannel.vue?vue&type=script&lang=js"
export * from "./ManageChannel.vue?vue&type=script&lang=js"

import "./channel-responsive.css?vue&type=style&index=0&lang=css&external"
import "./ManageChannel.vue?vue&type=style&index=1&id=ff247df4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff247df4"]])

export default __exports__